import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { initTempDashboard } from '@store/trends/tempDashboard/aiAlertDiagnostics/actions';
import tempDashboardSelector from '@store/trends/tempDashboard/aiAlertDiagnostics/selectors';
import { DASHBOARD_TYPE } from '@utils/constants';
import tempDashboard from '@src/pages/common/tempDashboard';
import { Main, AppExperience } from '@src/pages';
import initStore from './initStore';
import { selectedAiAlertMetricSelector } from '@src/store/trends/aiAlerts/selectors';

const aiAlertDiagnosticsDetailsSelector = createSelector(
  tempDashboardSelector,
  selectedAiAlertMetricSelector,
  (tempDashboardStore, selectedAIAlertMetric) => ({
    dashboardType: DASHBOARD_TYPE.AI_ALERT_DIAGNOSTICS,
    isFetching: tempDashboardStore.isFetching,
    initStore,
    selectedAIAlertMetric,
  }),
);

export const TempAiAlertDiagnostics = compose(
  connect(aiAlertDiagnosticsDetailsSelector, { init: initTempDashboard }),
  tempDashboard,
)(Main);

export const TempAppAiAlertDiagnostics = compose(
  connect(aiAlertDiagnosticsDetailsSelector, { init: initTempDashboard }),
  tempDashboard,
)(AppExperience);
